import React from "react";
import { Box } from "@mui/material";
import FilterBox from "./filter-box";
import CountFilterOptions from "./count-filter-options";

type CountFilterOnChange = (data: Record<string, string>, title?: string) => void;

interface MultiFilterGroupProps {
  filters: any[]; // Use your filter type here
  title: string;
  onChange?: CountFilterOnChange;
  values?: Record<string, string[]>; // Add values prop to track current selections
  isLoading?: boolean;
  
}

const MultiFilterGroup: React.FC<MultiFilterGroupProps> = ({ filters, title, onChange, values, isLoading = false }) => (
  <FilterBox name={title}>
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {filters.map((filterData) => (
        <CountFilterOptions
          key={filterData.fieldName}
          options={filterData.options}
          fieldName={filterData.fieldName}
          onChange={onChange}
          value={values ? values[filterData.fieldName] : []} // Pass current values for this field
          isLoading={isLoading}
          title={title}
        />
      ))}
    </Box>
  </FilterBox>
);

export default MultiFilterGroup;